import { defineTool } from '@/shell/tool';

/** Schools CRM: the CRM in a frame (Flutter's `schools-crm` embed). */
export default defineTool({
  id: 'vibes-schools-crm',
  title: 'Schools CRM',
  summary: 'The schools CRM, in a frame.',
  section: 'schools',
  order: 10,
  icon: 'school',
  owner: '@Drabu',
  permission: 'vibes-schools-crm:use',
  routes: () => import('./SchoolsCrmPage'),
});
